import Seo from "@/components/Seo";
import Hero from "@/pages/home/components/Hero";
import FocusPicks from "@/pages/home/components/FocusPicks";
import TrendingBoard from "@/pages/home/components/TrendingBoard";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestGrid from "@/pages/home/components/LatestGrid";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBand from "@/pages/home/components/CtaBand";
import { faqs, trendingTopics } from "@/mocks/site";
import { articles } from "@/mocks/articles";
import { site, SITE_ORIGIN } from "@/config/site";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: site.name,
      url: `${SITE_ORIGIN}/`,
      description: site.description,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_ORIGIN}/news?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.name,
      url: `${SITE_ORIGIN}/`,
      email: site.email,
      description: "专注娱乐热点、剧集讨论与网络话题整理的内容门户。",
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日必吃热榜",
      itemListElement: trendingTopics.map((topic, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: topic.title,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="诱惑吃瓜 - 精选头条热帖与高能猛料每日更新"
        description="诱惑吃瓜聚合全网娱乐热点、剧集讨论、综艺名场面与网络热议话题，精选头条、高能热帖、猛料爆评一站式呈现，带你第一时间进入吃瓜现场。"
        keywords="诱惑吃瓜,吃瓜头条,高能热帖,娱乐热点,猛料爆评,网络热议"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <FocusPicks />
      <TrendingBoard />
      <CategoryGrid />
      <LatestGrid />
      <Testimonials />
      <FaqSection />
      <CtaBand />

      <section aria-label="站点简介" className="border-t border-background-200 bg-background-50 px-4 py-10 md:px-6">
        <div className="max-w-3xl">
          <h2 className="font-heading text-lg font-bold text-foreground-950">
            关于诱惑吃瓜的内容范围
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            目前站内共收录 {articles.length} 篇整理稿，覆盖 {6} 个常驻栏目，内容以娱乐资讯梳理、节目复盘与话题观察为主。
            我们希望用更克制的方式呈现热点，把事实和观点分开摆，让你看完之后真的能明白发生了什么。
          </p>
        </div>
      </section>
    </>
  );
}